<div id="serviceEcole-page">
    <div class="cover-photo" style="position: relative; z-index: 3; left: 0; right: 0; height: 200px;">
    </div>

    <div class="extra-light-grey-cfa-languedoc-bg" style="position: relative; z-index: 10;">

        <div class="container white-bg pt-3">

            <div style="margin-left: -15px; margin-top: -110px !important; position: absolute; z-index: 12;">
                <h2 *ngIf="!isLoadingServiceEcoleInfo && titre_produit_readable" class="col-12 p-2 bandeau-title custom-background-color white font-weight-bold" style="display: table">{{titre_produit_readable}}</h2>
                <h1 *ngIf="!isLoadingServiceEcoleInfo && service_ecole_info && service_ecole_info.cible" class="col-12 p-2 bandeau-subtitle grey-cfa-languedoc-bg white font-weight-bold">{{service_ecole_info.cible}}</h1>
            </div>

            <div class="row">
                <div class="col-12 col-md-9 mt-5">

                    <div *ngIf="isLoadingServiceEcoleInfo" class="text-center">
                        <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        <p>Chargement des informations...</p>
                    </div>

                    <div *ngIf="!isLoadingServiceEcoleInfo && service_ecole_info" class="row p-2">
                        <div class="col-sm-12">
                            <p class="text-justify cfa-languedoc-paragraphe" [innerHTML]="service_ecole_info.bloc_desc_html1"></p>

                            <div *ngIf="!isLoadingB2b && b2b && b2b.cours" class="custom-background-color my-2">
                                <div class="row black-transparent">
                                    <div class="col-6 full-width-if-extra-small pt-2 pl-4 custom-color">
                                        <p class="large font-weight-bold text-uppercase">Matières de la préparation</p>
                                        <div *ngFor="let cours of course_column_1" class="mt-4">
                                            <div class="font-weight-bold" style="display: flex">
                                                <svg class="mt-2 mr-2" width="8px" height="8px" viewBox="0 0 500 500">
                                                    <polygon points="0,0 500,0 500,500, 0,500" style="fill:rgba(0,0,0,0.7); stroke-width: 0" />
                                                </svg>
                                                <h2 style="display: inline; margin: 0" class="libelle_cours">{{cours.libelle_complet | uppercase}}</h2>
                                            </div>
                                            <div class="my-1 small justify small-interline" [innerHTML]="cours.commentaire"></div>
                                        </div>
                                        <div class="hide-if-not-extra-small mt-4" *ngFor="let cours of course_column_2">
                                            <div class="font-weight-bold" style="display: flex">
                                                <svg class="mt-2 mr-2" width="8px" height="8px" viewBox="0 0 500 500">
                                                    <polygon points="0,0 500,0 500,500, 0,500" style="fill:rgba(0,0,0,0.5); stroke-width: 0" />
                                                </svg>
                                                <h2 style="display: inline; margin: 0" class="libelle_cours">{{cours.libelle_complet | uppercase}}</h2>
                                            </div>
                                            <div class="my-1 small justify small-interline" [innerHTML]="cours.commentaire"></div>
                                        </div>
                                    </div>
                                    <div class="hide-on-extra-small-only col-6 pt-2 pr-4 bl-2-dotted custom-color">
                                        <div *ngFor="let cours of course_column_2" class="mt-4">
                                            <div class="font-weight-bold" style="display: flex">
                                                <svg class="mt-2 mr-2" width="8px" height="8px" viewBox="0 0 500 500">
                                                    <polygon points="0,0 500,0 500,500, 0,500" style="fill:rgba(0,0,0,0.5); stroke-width: 0" />
                                                </svg>
                                                <h2 style="display: inline; margin: 0" class="libelle_cours">{{cours.libelle_complet | uppercase}}</h2>
                                            </div>
                                            <div class="my-1 small justify small-interline" [innerHTML]="cours.commentaire"></div>
                                        </div>
                                    </div>
                                    <div class="col-6 hide-on-extra-small-only"></div>
                                    <div class="col-6 full-width-if-extra-small bl-2-dotted">
                                        <div class="text-right">
                                            <svg style="right: 0" class="square-svg-width" viewBox="0 0 500 500">
                                                <polygon points="0,0 0,500 500,500 500,0" style="fill:rgba(255,255,255,0.4); stroke-width: 0" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Description détaillée -->
                        <div class="row col-12 m-2">
                            <p class="text-justify cfa-languedoc-paragraphe" [innerHTML]="service_ecole_info.bloc_desc_html2"></p>
                        </div>

                        <!-- Brochure + bouton contact -->
                        <div class="col-12 my-2 text-center">
                            <div class="row">
                                <div *ngIf="service_ecole_info.lien_brochure && service_ecole_info.lien_brochure !== ''" class="col-12 col-sm-6 col-lg-5 text-center mt-1">
                                    <a class="bouton-telecharger col-12" [href]="'https://www.apprentissage-montpellier.education/brochures/' + service_ecole_info.lien_brochure" target="_blank"> Télécharger la brochure </a>
                                </div>
    
                                <div class="col-12 col-sm-6 col-lg-7 text-center mt-1">
                                    <a class="bouton-inscription col-12" [href]="contactEcoleLink" [routerLink]="contactEcoleLink"> Prendre contact </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-3">
                    <!-- Responsable pédagogique -->
                    <div id="prof-b2b" *ngIf="!isLoadingProf && prof" class="row m-2">
                        <div *ngIf="prof && prof.prenom != null && prof.nom != null && prof.profil != null">
                            <p class="mb-0 text-color font-weight-bold">Responsable pédagogique</p>
                            <p class="text-color cfa-languedoc-paragraphe">{{prof.prenom}} {{prof.nom}}</p>
                            <div class="mt-3">
                                <img [src]="prof.photo? 'https://www.apprentissage-montpellier.education/img/profs/' + prof.photo : (environment.production? 'assets/img/prof.png' : '../../../assets/img/prof.png')" [alt]="prof.prenom && prof.nom? prof.prenom + ' ' + prof.nom : 'prod'" [title]="prof.prenom && prof.nom? prof.prenom + ' ' + prof.nom : 'prod'" class="img-prof mr-3 mb-1">
                                <p class="cfa-languedoc-paragraphe" style="font-size:13px !important">{{prof.profil}}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>